"use strict";
import axios from 'axios';
import UserService from "./../../../service/UserService"
/* import state from './state';
import actions from './actions';
import mutations from './mutations';
 import getters from "./getters"; */
export default {

/*   state,
  getters,
  actions,
  mutations */
  state:{
    entities:    new Array(),
    atualCompany:'',
    user:{
      id:'',
      logged:null,
      name:'',
      access:new Array(),
      email:'',
      token:'',
    },
  },
  getters:{
    getCompany    : state => state.atualCompany,
    getEntities   : state => state.entities,
    getStateLog   : state => state.user.logged,
    getUserLogged : state => state.user,
  },
  mutations:{
    setLoggedUser(state, payload ) {
      state.user.logged   = payload._id ? true : false;
      state.user.name     = payload.name;
      state.user.access   = payload.access;
      state.user.email    = payload.email;
      state.user.token    = payload.token;
      state.user.id       = payload._id;
    },
    loggoutUser(state, payload =0 ) {
      state.user.logged   = null;
      state.user.name     = "";
      state.user.access   = new Array();
      state.user.email    = "";
      state.user.token    = "";
      state.user.id       = "";  
      state.entities      = new Array();
      localStorage.removeItem('entities');
      localStorage.removeItem('company');
    },

    setEntities(state,payload){
      state.entities     = new Array();
      state.atualCompany = payload
      let userAccess     = UserService.getOneComapanyOfUser(state.atualCompany);
      if (userAccess) {
        for (let index = 0; index < userAccess.length; index++) {
          const element = userAccess[index].entity;
          state.entities.push(element);  
        } 
      }
      axios.defaults.headers['x-access-company'] = state.atualCompany;
      localStorage.setItem('entities', JSON.stringify(state.entities));
      localStorage.setItem('company' , JSON.stringify(state.atualCompany));
    },
  },
    
  

  actions:{
    loadLoggedUser(context){
      try {
        let loggedUser = JSON.parse(localStorage.getItem("loggedUser"));
        let company    = JSON.parse(localStorage.getItem("company"));
        if (loggedUser._id) {
          axios.defaults.headers['x-access-token'] = loggedUser.token;
          context.commit('setLoggedUser', loggedUser);
          if (company) {
            context.commit("setEntities", company);
          }
        }

      } catch (error) {
        console.log(error);
      }
      
    }
  }

}



// WEBPACK FOOTER //
// ./src/store/modules/user/main.js